import { axiosReadHelper } from '@finpay-development/shared-platform/lib/esm/shared/service/axios-read-helper';

export const getAuthDocTemplates = (clientId: number) =>
    axiosReadHelper({
        dataId: -2,
        url: `patient-encounter/v2/patient/encounter/config/authDocument/templates?clientId=${clientId}`,
    });

export const selectAuthDoc = (
    authDocsArr: Record<string, any>[],
    clientId: number,
    facilityId: number,
    docType: string
) => {
    //Check if facility level document exists
    const facLvlInstDoc = authDocsArr.find(
        (authDoc: Record<string, any>) =>
            authDoc.typeOfDoc === docType &&
            authDoc.clientId === clientId &&
            authDoc.clientFacilityId === facilityId
    );

    if (facLvlInstDoc) {
        return facLvlInstDoc;
    }

    //Check if client level document exists
    return authDocsArr.find(
        (authDoc: Record<string, any>) =>
            authDoc.typeOfDoc === docType &&
            authDoc.clientId === clientId &&
            authDoc.clientFacilityId === null
    );
};
